import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core'
import { cloneDeep, isEqual } from 'lodash'

export class MenuOption {
  text: string
  disable?: boolean
  tooltipMessage?: string
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnChanges {
  static lastTriggerElement: HTMLElement | null = null

  @Input() menuOptions: MenuOption[] = []
  @Input() ariaLabel: string = 'Open options menu'
  @Input() nodeId: string | null = null
  @Output() clickOption = new EventEmitter()
  _menuOptions: MenuOption[] = []

  @ViewChild('triggerEl', { read: ElementRef }) triggerEl: ElementRef<HTMLElement>

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.menuOptions && !isEqual(changes.menuOptions.currentValue, changes.menuOptions.previousValue)) {
      this._menuOptions = cloneDeep(changes.menuOptions.currentValue)
    }
  }

  constructor() { }

  _onClickOption(option: string) {
    MenuComponent.lastTriggerElement = this.triggerEl?.nativeElement ?? null
    this.clickOption.emit(option)
  }

}
